import { lazy, Suspense, useEffect } from "react";

import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrivacyPage } from "./pages/PrivacyPage";

const DevLinkPreviewRoute = import.meta.env.DEV
  ? lazy(async () => {
      const module = await import("./pages/LinkPreviewPage");
      return { default: module.LinkPreviewRoute };
    })
  : null;

const normalizePath = (path: string): string => {
  if (path === "/") return path;
  return path.replace(/\/+$/, "");
};

export function App() {
  const path = normalizePath(window.location.pathname);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [path]);

  if (path === "/") return <HomePage />;
  if (path === "/privacy") return <PrivacyPage />;
  if (DevLinkPreviewRoute && (path === "/__previews" || path === "/__previews/card")) {
    return (
      <Suspense fallback={null}>
        <DevLinkPreviewRoute />
      </Suspense>
    );
  }
  return <NotFoundPage />;
}
